// Reusable info row for driver detail displays
export const InfoRow = ({ label, value, className = '' }) => (
  <div className={className}>
    <p className="text-xs font-medium text-slate-500 uppercase">{label}</p>
    <p className="text-sm text-slate-900">{value || '-'}</p>
  </div>
);
